import React, { useState, useRef } from 'react';
import { Grid, IconButton, makeStyles, colors } from '@material-ui/core';
import { AddCircle } from '@material-ui/icons';

import Title from 'components/typography/Title';
import Description from 'components/typography/Description';
import ErrorMessage from 'components/typography/ErrorMessage';

import IngredientUIModel from 'domain/ui/models/IngredientUIModel';
import IngredientsList from './IngredientsList';
import IngredientsDialog from './IngredientsDialog';

const useStyles = makeStyles({
  addButton: {
    color: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[50],
    },
  },
});

const IngredientsInput = ({
  ingredientUIModels = [],
  setIngredientUIModels,
  errorMessage,
}) => {
  const addButtonElement = useRef(null);
  const [isAddDialogOpened, setIsAddDialogOpened] = useState(false);

  const classes = useStyles();

  const isListEmpty = !ingredientUIModels.length;

  const openDialog = () => {
    addButtonElement.current.blur();
    setIsAddDialogOpened(true);
  };
  const closeDialog = () => setIsAddDialogOpened(false);

  const addIngredient = (ingredient) => {
    const newIngredientUIModel = new IngredientUIModel(ingredient);
    setIngredientUIModels(ingredientUIModels.concat([newIngredientUIModel]));
  };

  const removeIngredient = (removedIngredient) => {
    setIngredientUIModels(
      ingredientUIModels.filter(
        (ingredient) => ingredient.id !== removedIngredient.id
      )
    );
  };

  const editIngredient = (oldIngredient, newIngredient) => {
    setIngredientUIModels(
      ingredientUIModels.map((ingredient) =>
        oldIngredient.id === ingredient.id ? newIngredient : ingredient
      )
    );
  };

  return (
    <React.Fragment>
      <Grid container direction="column">
        <Grid
          item
          container
          alignItems="center"
          spacing={3}
          style={{ marginBottom: 16 }}
        >
          <Grid item>
            <Title>Ingredients</Title>
          </Grid>
          <Grid item>
            <IconButton
              ref={addButtonElement}
              onClick={openDialog}
              className={classes.addButton}
            >
              <AddCircle></AddCircle>
            </IconButton>
          </Grid>
        </Grid>

        <Grid item>
          {isListEmpty && (
            <Description>
              <i>Add an ingredient</i>
            </Description>
          )}
        </Grid>

        <Grid item>
          <IngredientsList
            ingredientUIModels={ingredientUIModels}
            setIngredientUIModels={setIngredientUIModels}
            removeIngredient={removeIngredient}
            editIngredient={editIngredient}
          ></IngredientsList>
        </Grid>

        {errorMessage && (
          <Grid item style={{ marginTop: 16, marginBottom: 16 }}>
            <ErrorMessage>{errorMessage}</ErrorMessage>
          </Grid>
        )}
      </Grid>

      <IngredientsDialog
        isOpened={isAddDialogOpened}
        ingredientAction={addIngredient}
        closeDialog={closeDialog}
        title={'New Ingredient'}
        actionButtonLabel="Add"
      ></IngredientsDialog>
    </React.Fragment>
  );
};

export default IngredientsInput;
